import { render, staticRenderFns } from "./updatePasswordAdmin.vue?vue&type=template&id=4c939e7d"
import script from "./updatePasswordAdmin.vue?vue&type=script&lang=js"
export * from "./updatePasswordAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports